/* eslint-disable max-len */
import produce, { castDraft, } from 'immer';
import { FirmwareActionType, } from './actions';
const channelsByProjectIdByDeviceClassIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case FirmwareActionType.SET_FIRMWARE_CHANNELS:
            return produce(currentState, (draft) => {
                const { projectId, channels } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                channels.forEach((channel) => {
                    temp[channel.id] = castDraft(channel);
                });
            });
        case FirmwareActionType.CLEAR_FIRMWARE_CHANNELS:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const channelIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case FirmwareActionType.SET_FIRMWARE_CHANNELS:
            return produce(currentState, (draft) => {
                const { projectId, channels, searchParams } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[searchParams] = channels.map((channel) => {
                    return channel.id;
                });
            });
        case FirmwareActionType.CLEAR_FIRMWARE_CHANNELS:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const bundlesByProjectIdByDeviceClassIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case FirmwareActionType.SET_FIRMWARE_BUNDLES:
            return produce(currentState, (draft) => {
                const { projectId, bundles } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                bundles.forEach((bundle) => {
                    temp[bundle.id] = castDraft(bundle);
                });
            });
        case FirmwareActionType.CLEAR_FIRMWARE_BUNDLES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const bundleIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case FirmwareActionType.SET_FIRMWARE_BUNDLES:
            return produce(currentState, (draft) => {
                const { projectId, bundles, searchParams } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[searchParams] = bundles.map((bundle) => {
                    return bundle.id;
                });
            });
        case FirmwareActionType.CLEAR_FIRMWARE_BUNDLES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
export const firmwareStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.channelsByProjectIdByDeviceClassId = castDraft(channelsByProjectIdByDeviceClassIdReducer(currentState.channelsByProjectIdByDeviceClassId, action));
        draft.channelIdsByProjectId = castDraft(channelIdsByProjectIdReducer(currentState.channelIdsByProjectId, action));
        draft.bundlesByProjectIdByDeviceClassId = castDraft(bundlesByProjectIdByDeviceClassIdReducer(currentState.bundlesByProjectIdByDeviceClassId, action));
        draft.bundleIdsByProjectId = castDraft(bundleIdsByProjectIdReducer(currentState.bundleIdsByProjectId, action));
    });
};
